import SimpleTable from "@/components/SimpleTable";
import { Button } from "@/components/ui/button";
import { AnswerSheet } from "@/schema/console/certifications/AnswerSheet";
import { format } from "date-fns";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";

interface AnswerSheetTableProps {
  id: string;
  data: AnswerSheet[];
}

function AnswerSheetTable({ id, data }: AnswerSheetTableProps) {
  const navigate = useNavigate();
  const { t } = useTranslation();
  return (
    <SimpleTable
      data={data}
      columns={[
        {
          key: "title",
          label: t("assessment-result"),
          render: ({ is_first_time }) => (
            <p className=" text-sm font-medium text-cool-gray-700">
              {is_first_time
                ? t("first-assessment-report")
                : t("re-assessment-report")}
            </p>
          ),
        },
        {
          key: "completedDate",
          label: "",
          render: ({ updated_at }) => (
            <p className=" text-sm font-normal text-cool-gray-600">{`${t("completed-on")} ${format(updated_at, t("date-format"))}`}</p>
          ),
        },
        {
          width: "112px",
          key: "action",
          label: "",
          render: ({ is_first_time }) => (
            <Button
              variant="outline"
              onClick={() => {
                navigate(
                  `/console/assessment-results/${id}?isFirstTime=${is_first_time}`,
                );
              }}
            >
              {t("view")}
            </Button>
          ),
        },
      ]}
    />
  );
}

export default AnswerSheetTable;
